// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ProductListTag: MarkdocTagRegistration = {
  tag: 'product-list',
  component: 'ProductList',
  attributes: {
    showBanking: {
      type: Boolean,
      default: false,
      description: `Whether to show the Treasury product badge`,
    },
    showCorporateCard: {
      type: Boolean,
      default: false,
      description: `Whether to show the Corporate Card product badge`,
    },
    showOpal: {
      type: Boolean,
      default: false,
      description: `Whether to show the Opal product badge`,
    },
  },
};
